export default function formatTime(value, lang = "fr") {
  const date = new Date(value)
  const hours = date.getHours()
  const minutes = date.getMinutes()

  return `${hours}h${minutes > 0 ? `${minutes}` : ""}`
}
